import { API_BASE_URL } from "../config/apiConfig";


const fetchAPI = async (endpoint, method = "GET", body = null, token = null) => {
    const headers = {
        "Content-Type": "application/json",
    };

    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    const options = {
        method,
        headers,
    };

    if (body) {
        options.body = JSON.stringify(body);
        console.log(body)
    }

    const response = await fetch(`${API_BASE_URL}/api/users/${endpoint}`, options);
    return response.json();
};

// Delete a company by ID
export const deleteUser = async (id) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/users/${id}`, {
            method: "DELETE",
        });

        if (!response.ok) {
            throw new Error(`Failed to delete company with ID: ${id}`);
        }

        return await response.json();
    } catch (error) {
        console.error(`Error deleting company with ID ${id}:`, error);
        throw error;
    }
};

// Register Admin
export const registerUser = (data) => fetchAPI("register", "POST", data);

// Login Admin
export const loginUser = (data) => fetchAPI("login", "POST", data);

// Get All Users
export const getUsers = (token) => fetchAPI("", "GET", null, token);



// Get Single Admin
export const getSingleUser = (id, token) => fetchAPI(`${id}`, "GET", null, token);

// Update User Details
export const updateUserDetails = (id, data) => fetchAPI(`${id}`, "PUT", data);

// Update Profile Image
export const updateProfileImage = async (id, file, token) => {
    const formData = new FormData();
    formData.append("profile_image", file);

    const response = await fetch(`${API_BASE_URL}/${id}/profile-image`, {
        method: "PUT",
        headers: {
            "Authorization": `Bearer ${token}`,
        },
        body: formData,
    });

    return response.json();
};

// Delete Profile Image
export const deleteProfileImage = (id, token) => fetchAPI(`${id}/delete-profile-image`, "DELETE", null, token);

// Forgot Password (Send OTP)
export const sendForgotPasswordEmail = (data) => fetchAPI("forgot-password", "POST", data);

// Verify OTP
export const verifyOTP = (data) => fetchAPI("verify-otp", "POST", data);

// Reset Password
export const resetPassword = (data) => fetchAPI("reset-password", "POST", data);

// Generate New OTP
export const generateNewOtp = (data) => fetchAPI("generate-new-otp", "POST", data);
